define('modules/map/map_zone_picker_modal_view',[
  'backbone',
  'jquery',
  '_',
  'text!./map_zone_picker_modal_template.html'
], function (Backbone, $, _,
             modal_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.render();
    },

    tagName: 'div',
    className: 'zone-picker-modal',
    template: _.template(modal_template),

    render: function () {
      this.$el.html(this.template(this.player));
      return this;
    },

    remove: function () {
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

